const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/DashboardCardConfiguration.ts';
import { CardSize, DashboardCard } from 'App/pages/DashboardPage/utils/configToCardMapper';

export const dashboardCardConfiguration: DashboardCard[] = [
    {
        CardSize: CardSize.L,
        CardType: 'ECheckin',
        Priority: 1,
    },
    {
        CardSize: CardSize.M,
        CardType: 'NextAppointment',
        Priority: 1,
    },
    {
        CardSize: CardSize.M,
        CardType: 'NextSurgeryAppointmentCard',
        Priority: 1,
    },
    {
        CardSize: CardSize.M,
        CardType: 'Medication',
        Priority: 1,
    },
    {
        CardSize: CardSize.M,
        CardType: 'Responsibility',
        Priority: 2,
    },
    {
        CardSize: CardSize.M,
        CardType: 'Invoice',
        Priority: 2,
    },
    {
        CardSize: CardSize.M,
        CardType: 'Reports',
        Priority: 1,
    },
    {
        CardSize: CardSize.M,
        CardType: 'SynedraViewer',
        Priority: 4,
    },
    {
        CardSize: CardSize.M,
        CardType: 'IdentityProof',
        Priority: 1,
    },
    {
        CardSize: CardSize.M,
        CardType: 'HospitalImage',
        Priority: 1,
    },
    {
        CardSize: CardSize.S,
        CardType: 'BookAppointmentCard',
        Priority: 2,
    },
    {
        CardSize: CardSize.S,
        CardType: 'ExternalLinks',
        Priority: 1000,
    },
];
